import React,{useState, useEffect}  from 'react';
import Card from 'react-bootstrap/Card';
import Cppbar from '../Bars/Cppbar';
import Button from 'react-bootstrap/Button'

function Cconditionoper(){
return(
    <div>
       
    <h1>C conditional operator</h1>
  
    <div className="first">
        <a href="/csharp-control-structure"><Button className="ab" variant="primary" size="lg">&#60; Previous</Button></a> 
        <a href="/csharp-if-else"><Button className="cd" variant="primary" size="lg"> Next &#62;</Button></a> 
        </div>
    <h2 className="mt-4 mh2">Syntax for conditional operator in C </h2>

<Card border="primary m-4">
<Card.Header as="h5">Syntax for conditional operator in C :</Card.Header>
<Card.Body>

<Card.Text>
<p>
Expression 1? Expression2: expression 3
</p>
</Card.Text>

</Card.Body>
<Card.Footer>This is a comment  example in C</Card.Footer>
</Card>

<p className="mt-3 para">"if expression 1 is true (if a value is non-zero), then the value returned will be expression 2, otherwise the value returned will be expression 3". </p>

<Card border="primary m-4">
<Card.Header as="h5">example of conditional operator in C :</Card.Header>
<Card.Body>
<Card.Title>conditional operator use  ?:</Card.Title>
<Card.Text>
<p>
a=200>50?100 :25

</p>
</Card.Text>

</Card.Body>
<Card.Footer>This is a comment  example in C</Card.Footer>
</Card>
<h2 className="mt-4 mh2">
Ans-100
</h2>

<Card border="primary m-4">
<Card.Header as="h5">example of conditional operator in C :</Card.Header>
<Card.Body>
<Card.Text>
<p>
int a=10,b;
B=(a>8?true:false)
</p>
</Card.Text>
</Card.Body>
</Card>

<h1 className="mt-5">  </h1>
<div className="back">
        <a href="/csharp-goto"><Button className="ab" variant="primary" size="lg">&#60; Previous</Button></a> 
        <a href="/csharp-oops"><Button className="cd" variant="primary" size="lg"> Next &#62;</Button></a> 
        </div>
    </div>
)

}
export default Cconditionoper;